module.exports = __webpack_public_path__ + "img/bot_event_info_day3.8fa1bc00.png";